import { Observable } from 'rxjs/Observable';
import { RootModel } from './root.model';

export class ObjectObservable<K extends keyof RootModel> extends Observable<
  RootModel[K]
> {
  constructor(source: Observable<any>) {
    super();
    this.source = source;
  }

  set(value: any): Observable<void> {
    return Observable.of(undefined);
  }

  update(value: Object): Observable<void> {
    return Observable.of(undefined);
  }

  remove(): Observable<void> {
    return Observable.of(undefined);
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/object-observable.ts